import Vue from 'vue'
import VueRouter from 'vue-router'
import exercicio from '@/views/exercicio'
import formInicio from '@/views/form-inicio'
import relatorio from '@/views/relatorio'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'formInicio',
    component: formInicio
    // beforeEnter: (to, from, next) => {
    //   if (localStorage['inicio'] === true) next()
    // }
  },
  {
    path: '/exercicio',
    name: 'exercicio',
    component: exercicio,
    beforeEnter: (to, from, next) => {
      if (JSON.parse(localStorage['inicio']) === true) {
        next()
      } else {
        next('/')
      }
    }
  },
  {
    path: '/relatorio',
    name: 'relatorio',
    component: relatorio,
    beforeEnter: (to, from, next) => {
      if (JSON.parse(localStorage['inicio']) === true) {
        next()
      } else {
        next('/')
      }
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
